import { get, post, put, del } from './client';

export const getWikiPages = () => get('/api/wiki-pages');

export const getWikiPage = (pageId) => get(`/api/wiki-pages/${pageId}`);

export const createWikiPage = (pageData) => post('/api/wiki-pages', pageData);

export const updateWikiPage = (pageId, pageData) => put(`/api/wiki-pages/${pageId}`, pageData);

export const reorderWikiPages = (parentId, orderedIds) => put('/api/wiki-pages/reorder', { parentId, orderedIds });

export const deleteWikiPage = (pageId) => del(`/api/wiki-pages/${pageId}`);

export const uploadWikiImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return post('/api/wiki-images', formData);
};
